/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FreeMockOverview,
  MarketingSettings,
  MarketingSettingsListParams,
  MarketingWebinarsListParams,
  PaginatedMarketingSettingsList,
  PaginatedWebinarList,
  PatchedFreeMockSettingsRequest,
  PatchedMarketingSettingsRequest,
  PatchedWebinarRequest,
  Webinar,
  WebinarLink,
  WebinarRegistration,
  WebinarRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type marketingSettingsListResponse200 = {
  data: PaginatedMarketingSettingsList
  status: 200
}
    
export type marketingSettingsListResponseSuccess = (marketingSettingsListResponse200) & {
  headers: Headers;
};
;

export type marketingSettingsListResponse = (marketingSettingsListResponseSuccess)

export const getMarketingSettingsListUrl = (params?: MarketingSettingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/marketing/settings/?${stringifiedParams}` : `/api/v1/marketing/settings/`
}

export const marketingSettingsList = async (params?: MarketingSettingsListParams, options?: RequestInit): Promise<marketingSettingsListResponse> => {
  
  return apiFetch<marketingSettingsListResponse>(getMarketingSettingsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getMarketingSettingsListQueryKey = (params?: MarketingSettingsListParams,) => {
    return [
    `/api/v1/marketing/settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMarketingSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof marketingSettingsList>>, TError = unknown>(params?: MarketingSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketingSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketingSettingsList>>> = ({ signal }) => marketingSettingsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof marketingSettingsList>>>
export type MarketingSettingsListQueryError = unknown


export function useMarketingSettingsList<TData = Awaited<ReturnType<typeof marketingSettingsList>>, TError = unknown>(
 params: undefined |  MarketingSettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingSettingsList>>,
          TError,
          Awaited<ReturnType<typeof marketingSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingSettingsList<TData = Awaited<ReturnType<typeof marketingSettingsList>>, TError = unknown>(
 params?: MarketingSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingSettingsList>>,
          TError,
          Awaited<ReturnType<typeof marketingSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingSettingsList<TData = Awaited<ReturnType<typeof marketingSettingsList>>, TError = unknown>(
 params?: MarketingSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMarketingSettingsList<TData = Awaited<ReturnType<typeof marketingSettingsList>>, TError = unknown>(
 params?: MarketingSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarketingSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type marketingSettingsRetrieveResponse200 = {
  data: MarketingSettings
  status: 200
}
    
export type marketingSettingsRetrieveResponseSuccess = (marketingSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type marketingSettingsRetrieveResponse = (marketingSettingsRetrieveResponseSuccess)

export const getMarketingSettingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/marketing/settings/${id}/`
}

export const marketingSettingsRetrieve = async (id: string, options?: RequestInit): Promise<marketingSettingsRetrieveResponse> => {
  
  return apiFetch<marketingSettingsRetrieveResponse>(getMarketingSettingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getMarketingSettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketing/settings/${id}/`
    ] as const;
    }

    
export const getMarketingSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketingSettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketingSettingsRetrieve>>> = ({ signal }) => marketingSettingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof marketingSettingsRetrieve>>>
export type MarketingSettingsRetrieveQueryError = unknown


export function useMarketingSettingsRetrieve<TData = Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof marketingSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingSettingsRetrieve<TData = Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof marketingSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingSettingsRetrieve<TData = Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMarketingSettingsRetrieve<TData = Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarketingSettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type marketingSettingsPartialUpdateResponse200 = {
  data: MarketingSettings
  status: 200
}
    
export type marketingSettingsPartialUpdateResponseSuccess = (marketingSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type marketingSettingsPartialUpdateResponse = (marketingSettingsPartialUpdateResponseSuccess)

export const getMarketingSettingsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/marketing/settings/${id}/`
}

export const marketingSettingsPartialUpdate = async (id: string,
    patchedMarketingSettingsRequest: PatchedMarketingSettingsRequest, options?: RequestInit): Promise<marketingSettingsPartialUpdateResponse> => {
  
  return apiFetch<marketingSettingsPartialUpdateResponse>(getMarketingSettingsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedMarketingSettingsRequest,)
  }
);}




export const getMarketingSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingSettingsPartialUpdate>>, TError,{id: string;data: PatchedMarketingSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof marketingSettingsPartialUpdate>>, TError,{id: string;data: PatchedMarketingSettingsRequest}, TContext> => {

const mutationKey = ['marketingSettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof marketingSettingsPartialUpdate>>, {id: string;data: PatchedMarketingSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  marketingSettingsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarketingSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof marketingSettingsPartialUpdate>>>
    export type MarketingSettingsPartialUpdateMutationBody = PatchedMarketingSettingsRequest
    export type MarketingSettingsPartialUpdateMutationError = unknown

    export const useMarketingSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingSettingsPartialUpdate>>, TError,{id: string;data: PatchedMarketingSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof marketingSettingsPartialUpdate>>,
        TError,
        {id: string;data: PatchedMarketingSettingsRequest},
        TContext
      > => {

      const mutationOptions = getMarketingSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * D-172: the free mock of learners without a subscription: per exam and German level,
the mock offered and whether it is published; its activity and its settings.
 */
export type marketingSettingsFreeMockRetrieveResponse200 = {
  data: FreeMockOverview
  status: 200
}
    
export type marketingSettingsFreeMockRetrieveResponseSuccess = (marketingSettingsFreeMockRetrieveResponse200) & {
  headers: Headers;
};
;

export type marketingSettingsFreeMockRetrieveResponse = (marketingSettingsFreeMockRetrieveResponseSuccess)

export const getMarketingSettingsFreeMockRetrieveUrl = () => {


  

  return `/api/v1/marketing/settings/free-mock/`
}

export const marketingSettingsFreeMockRetrieve = async ( options?: RequestInit): Promise<marketingSettingsFreeMockRetrieveResponse> => {
  
  return apiFetch<marketingSettingsFreeMockRetrieveResponse>(getMarketingSettingsFreeMockRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getMarketingSettingsFreeMockRetrieveQueryKey = () => {
    return [
    `/api/v1/marketing/settings/free-mock/`
    ] as const;
    }

    
export const getMarketingSettingsFreeMockRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketingSettingsFreeMockRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>> = ({ signal }) => marketingSettingsFreeMockRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingSettingsFreeMockRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>>
export type MarketingSettingsFreeMockRetrieveQueryError = unknown


export function useMarketingSettingsFreeMockRetrieve<TData = Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>,
          TError,
          Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingSettingsFreeMockRetrieve<TData = Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>,
          TError,
          Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingSettingsFreeMockRetrieve<TData = Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMarketingSettingsFreeMockRetrieve<TData = Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingSettingsFreeMockRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarketingSettingsFreeMockRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type marketingSettingsFreeMockPartialUpdateResponse200 = {
  data: FreeMockOverview
  status: 200
}
    
export type marketingSettingsFreeMockPartialUpdateResponseSuccess = (marketingSettingsFreeMockPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type marketingSettingsFreeMockPartialUpdateResponse = (marketingSettingsFreeMockPartialUpdateResponseSuccess)

export const getMarketingSettingsFreeMockPartialUpdateUrl = () => {


  

  return `/api/v1/marketing/settings/free-mock/`
}

export const marketingSettingsFreeMockPartialUpdate = async (patchedFreeMockSettingsRequest: PatchedFreeMockSettingsRequest, options?: RequestInit): Promise<marketingSettingsFreeMockPartialUpdateResponse> => {
  
  return apiFetch<marketingSettingsFreeMockPartialUpdateResponse>(getMarketingSettingsFreeMockPartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedFreeMockSettingsRequest,)
  }
);}




export const getMarketingSettingsFreeMockPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingSettingsFreeMockPartialUpdate>>, TError,{data: PatchedFreeMockSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof marketingSettingsFreeMockPartialUpdate>>, TError,{data: PatchedFreeMockSettingsRequest}, TContext> => {

const mutationKey = ['marketingSettingsFreeMockPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof marketingSettingsFreeMockPartialUpdate>>, {data: PatchedFreeMockSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  marketingSettingsFreeMockPartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarketingSettingsFreeMockPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof marketingSettingsFreeMockPartialUpdate>>>
    export type MarketingSettingsFreeMockPartialUpdateMutationBody = PatchedFreeMockSettingsRequest
    export type MarketingSettingsFreeMockPartialUpdateMutationError = unknown

    export const useMarketingSettingsFreeMockPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingSettingsFreeMockPartialUpdate>>, TError,{data: PatchedFreeMockSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof marketingSettingsFreeMockPartialUpdate>>,
        TError,
        {data: PatchedFreeMockSettingsRequest},
        TContext
      > => {

      const mutationOptions = getMarketingSettingsFreeMockPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type marketingWebinarsListResponse200 = {
  data: PaginatedWebinarList
  status: 200
}
    
export type marketingWebinarsListResponseSuccess = (marketingWebinarsListResponse200) & {
  headers: Headers;
};
;

export type marketingWebinarsListResponse = (marketingWebinarsListResponseSuccess)

export const getMarketingWebinarsListUrl = (params?: MarketingWebinarsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/marketing/webinars/?${stringifiedParams}` : `/api/v1/marketing/webinars/`
}

export const marketingWebinarsList = async (params?: MarketingWebinarsListParams, options?: RequestInit): Promise<marketingWebinarsListResponse> => {
  
  return apiFetch<marketingWebinarsListResponse>(getMarketingWebinarsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getMarketingWebinarsListQueryKey = (params?: MarketingWebinarsListParams,) => {
    return [
    `/api/v1/marketing/webinars/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMarketingWebinarsListQueryOptions = <TData = Awaited<ReturnType<typeof marketingWebinarsList>>, TError = unknown>(params?: MarketingWebinarsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketingWebinarsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketingWebinarsList>>> = ({ signal }) => marketingWebinarsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingWebinarsListQueryResult = NonNullable<Awaited<ReturnType<typeof marketingWebinarsList>>>
export type MarketingWebinarsListQueryError = unknown


export function useMarketingWebinarsList<TData = Awaited<ReturnType<typeof marketingWebinarsList>>, TError = unknown>(
 params: undefined |  MarketingWebinarsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingWebinarsList>>,
          TError,
          Awaited<ReturnType<typeof marketingWebinarsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingWebinarsList<TData = Awaited<ReturnType<typeof marketingWebinarsList>>, TError = unknown>(
 params?: MarketingWebinarsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingWebinarsList>>,
          TError,
          Awaited<ReturnType<typeof marketingWebinarsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingWebinarsList<TData = Awaited<ReturnType<typeof marketingWebinarsList>>, TError = unknown>(
 params?: MarketingWebinarsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMarketingWebinarsList<TData = Awaited<ReturnType<typeof marketingWebinarsList>>, TError = unknown>(
 params?: MarketingWebinarsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarketingWebinarsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type marketingWebinarsCreateResponse201 = {
  data: Webinar
  status: 201
}
    
export type marketingWebinarsCreateResponseSuccess = (marketingWebinarsCreateResponse201) & {
  headers: Headers;
};
;

export type marketingWebinarsCreateResponse = (marketingWebinarsCreateResponseSuccess)

export const getMarketingWebinarsCreateUrl = () => {


  

  return `/api/v1/marketing/webinars/`
}

export const marketingWebinarsCreate = async (webinarRequest: WebinarRequest, options?: RequestInit): Promise<marketingWebinarsCreateResponse> => {
  
  return apiFetch<marketingWebinarsCreateResponse>(getMarketingWebinarsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      webinarRequest,)
  }
);}




export const getMarketingWebinarsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsCreate>>, TError,{data: WebinarRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsCreate>>, TError,{data: WebinarRequest}, TContext> => {

const mutationKey = ['marketingWebinarsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof marketingWebinarsCreate>>, {data: WebinarRequest}> = (props) => {
          const {data} = props ?? {};

          return  marketingWebinarsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarketingWebinarsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof marketingWebinarsCreate>>>
    export type MarketingWebinarsCreateMutationBody = WebinarRequest
    export type MarketingWebinarsCreateMutationError = unknown

    export const useMarketingWebinarsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsCreate>>, TError,{data: WebinarRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof marketingWebinarsCreate>>,
        TError,
        {data: WebinarRequest},
        TContext
      > => {

      const mutationOptions = getMarketingWebinarsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type marketingWebinarsRetrieveResponse200 = {
  data: Webinar
  status: 200
}
    
export type marketingWebinarsRetrieveResponseSuccess = (marketingWebinarsRetrieveResponse200) & {
  headers: Headers;
};
;

export type marketingWebinarsRetrieveResponse = (marketingWebinarsRetrieveResponseSuccess)

export const getMarketingWebinarsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/marketing/webinars/${id}/`
}

export const marketingWebinarsRetrieve = async (id: string, options?: RequestInit): Promise<marketingWebinarsRetrieveResponse> => {
  
  return apiFetch<marketingWebinarsRetrieveResponse>(getMarketingWebinarsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getMarketingWebinarsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketing/webinars/${id}/`
    ] as const;
    }

    
export const getMarketingWebinarsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketingWebinarsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketingWebinarsRetrieve>>> = ({ signal }) => marketingWebinarsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingWebinarsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof marketingWebinarsRetrieve>>>
export type MarketingWebinarsRetrieveQueryError = unknown


export function useMarketingWebinarsRetrieve<TData = Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingWebinarsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof marketingWebinarsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingWebinarsRetrieve<TData = Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingWebinarsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof marketingWebinarsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingWebinarsRetrieve<TData = Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMarketingWebinarsRetrieve<TData = Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarketingWebinarsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type marketingWebinarsPartialUpdateResponse200 = {
  data: Webinar
  status: 200
}
    
export type marketingWebinarsPartialUpdateResponseSuccess = (marketingWebinarsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type marketingWebinarsPartialUpdateResponse = (marketingWebinarsPartialUpdateResponseSuccess)

export const getMarketingWebinarsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/marketing/webinars/${id}/`
}

export const marketingWebinarsPartialUpdate = async (id: string,
    patchedWebinarRequest: PatchedWebinarRequest, options?: RequestInit): Promise<marketingWebinarsPartialUpdateResponse> => {
  
  return apiFetch<marketingWebinarsPartialUpdateResponse>(getMarketingWebinarsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedWebinarRequest,)
  }
);}




export const getMarketingWebinarsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsPartialUpdate>>, TError,{id: string;data: PatchedWebinarRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsPartialUpdate>>, TError,{id: string;data: PatchedWebinarRequest}, TContext> => {

const mutationKey = ['marketingWebinarsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof marketingWebinarsPartialUpdate>>, {id: string;data: PatchedWebinarRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  marketingWebinarsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarketingWebinarsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof marketingWebinarsPartialUpdate>>>
    export type MarketingWebinarsPartialUpdateMutationBody = PatchedWebinarRequest
    export type MarketingWebinarsPartialUpdateMutationError = unknown

    export const useMarketingWebinarsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsPartialUpdate>>, TError,{id: string;data: PatchedWebinarRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof marketingWebinarsPartialUpdate>>,
        TError,
        {id: string;data: PatchedWebinarRequest},
        TContext
      > => {

      const mutationOptions = getMarketingWebinarsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type marketingWebinarsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type marketingWebinarsDestroyResponseSuccess = (marketingWebinarsDestroyResponse204) & {
  headers: Headers;
};
;

export type marketingWebinarsDestroyResponse = (marketingWebinarsDestroyResponseSuccess)

export const getMarketingWebinarsDestroyUrl = (id: string,) => {


  

  return `/api/v1/marketing/webinars/${id}/`
}

export const marketingWebinarsDestroy = async (id: string, options?: RequestInit): Promise<marketingWebinarsDestroyResponse> => {
  
  return apiFetch<marketingWebinarsDestroyResponse>(getMarketingWebinarsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getMarketingWebinarsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['marketingWebinarsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof marketingWebinarsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  marketingWebinarsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarketingWebinarsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof marketingWebinarsDestroy>>>
    
    export type MarketingWebinarsDestroyMutationError = unknown

    export const useMarketingWebinarsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof marketingWebinarsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getMarketingWebinarsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type marketingWebinarsRegenerateLinkCreateResponse200 = {
  data: WebinarLink
  status: 200
}
    
export type marketingWebinarsRegenerateLinkCreateResponseSuccess = (marketingWebinarsRegenerateLinkCreateResponse200) & {
  headers: Headers;
};
;

export type marketingWebinarsRegenerateLinkCreateResponse = (marketingWebinarsRegenerateLinkCreateResponseSuccess)

export const getMarketingWebinarsRegenerateLinkCreateUrl = (id: string,) => {


  

  return `/api/v1/marketing/webinars/${id}/regenerate-link/`
}

export const marketingWebinarsRegenerateLinkCreate = async (id: string, options?: RequestInit): Promise<marketingWebinarsRegenerateLinkCreateResponse> => {
  
  return apiFetch<marketingWebinarsRegenerateLinkCreateResponse>(getMarketingWebinarsRegenerateLinkCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getMarketingWebinarsRegenerateLinkCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsRegenerateLinkCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsRegenerateLinkCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['marketingWebinarsRegenerateLinkCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof marketingWebinarsRegenerateLinkCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  marketingWebinarsRegenerateLinkCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarketingWebinarsRegenerateLinkCreateMutationResult = NonNullable<Awaited<ReturnType<typeof marketingWebinarsRegenerateLinkCreate>>>
    
    export type MarketingWebinarsRegenerateLinkCreateMutationError = unknown

    export const useMarketingWebinarsRegenerateLinkCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof marketingWebinarsRegenerateLinkCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof marketingWebinarsRegenerateLinkCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getMarketingWebinarsRegenerateLinkCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type marketingWebinarsRegistrationsListResponse200 = {
  data: WebinarRegistration[]
  status: 200
}
    
export type marketingWebinarsRegistrationsListResponseSuccess = (marketingWebinarsRegistrationsListResponse200) & {
  headers: Headers;
};
;

export type marketingWebinarsRegistrationsListResponse = (marketingWebinarsRegistrationsListResponseSuccess)

export const getMarketingWebinarsRegistrationsListUrl = (id: string,) => {


  

  return `/api/v1/marketing/webinars/${id}/registrations/`
}

export const marketingWebinarsRegistrationsList = async (id: string, options?: RequestInit): Promise<marketingWebinarsRegistrationsListResponse> => {
  
  return apiFetch<marketingWebinarsRegistrationsListResponse>(getMarketingWebinarsRegistrationsListUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getMarketingWebinarsRegistrationsListQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketing/webinars/${id}/registrations/`
    ] as const;
    }

    
export const getMarketingWebinarsRegistrationsListQueryOptions = <TData = Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMarketingWebinarsRegistrationsListQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>> = ({ signal }) => marketingWebinarsRegistrationsList(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MarketingWebinarsRegistrationsListQueryResult = NonNullable<Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>>
export type MarketingWebinarsRegistrationsListQueryError = unknown


export function useMarketingWebinarsRegistrationsList<TData = Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>,
          TError,
          Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingWebinarsRegistrationsList<TData = Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>,
          TError,
          Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMarketingWebinarsRegistrationsList<TData = Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMarketingWebinarsRegistrationsList<TData = Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof marketingWebinarsRegistrationsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMarketingWebinarsRegistrationsListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




